import { Fragment as messaging } from 'react';

export default messaging;
